module.exports = __webpack_public_path__ + "img/DNADamage-CECA_10X_CC.544b6e7e.png";